import { useId } from 'react';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';
import documentTitleRegistry from 'utils/documentTitle';

const useDocumentTitle = (title, { defaultTitle, titleTemplate, prefix } = {}) => {
  const entryId = useId();

  documentTitleRegistry.claimEntry(entryId);

  useEffectSafeStrictMode(() => {
    documentTitleRegistry.setEntry(entryId, { title, defaultTitle, titleTemplate, prefix });
  }, [entryId, title, defaultTitle, titleTemplate, prefix]);

  useEffectSafeStrictMode(() => () => documentTitleRegistry.removeEntry(entryId), [entryId]);
};

export default useDocumentTitle;
